import { PropsWithChildren } from "react";
import GlobalStyle from "./globals";
import TypographyStyle from "./typography";
import SectionSpacingStyle from "./sectionSpacing";
import TransitionsStyle from "./transitions";
import InputsStyle from "./inputs";

const GlobalStyleComponent = (props: PropsWithChildren<any>) => {
  return (
    <>
      <GlobalStyle />
      <TypographyStyle />
      <SectionSpacingStyle />
      <TransitionsStyle />
      <InputsStyle />
      {props.children}
    </>
  );
};

export default GlobalStyleComponent;
